import script from "./NewBaseTableContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewBaseTableContent.vue?vue&type=script&lang=ts&setup=true"

import "./NewBaseTableContent.vue?vue&type=style&index=0&id=04399a31&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04399a31"]])

export default __exports__